import "./Companies.css";
import { Container } from "react-bootstrap";
const Companies = () => {
  const imgPathes = ["realty", "tower", "prologis", "equinix"];

  const maping = imgPathes.map((e, i) => {
    return (
      <div className="sponsore col-md-5 col-lg-2 m-4" key={i}>
        <img
          src={require(`../../imgs/${e}.png`)}
          alt=""
          className="img-fluid"
        />
      </div>
    );
  });
  return (
    <div>
      <Container>
        <h1 className="text-center pt-5">Our Partner</h1>
        <div className="row pt-5 justify-content-center">{maping}</div>
      </Container>
    </div>
  );
};

export default Companies;
